import { eligibleBillingProvider } from '@libs/enums';
import { CheckboxGroupField, TextStringField } from '@ps-smart-cp/ppfw-client';
import { leaseCompanyMstListSearchFieldConfig } from '../item-config';
import type { LeaseCompanyMstListSearch } from '../models';

export function AdditionalSearchBasicInfo(
  mstSearch: LeaseCompanyMstListSearch,
  setMstSearch: (t: LeaseCompanyMstListSearch) => void,
  errorFields?: string[],
) {
  return (
    <>
      <TextStringField
        obj={mstSearch}
        setObj={setMstSearch}
        prop="phoneNo"
        items={leaseCompanyMstListSearchFieldConfig}
        errorFields={errorFields}
      />
      <CheckboxGroupField
        obj={mstSearch}
        setObj={setMstSearch}
        prop="eligibleBillingProviderCondition"
        items={leaseCompanyMstListSearchFieldConfig}
        enumType={eligibleBillingProvider.enum}
        enumNameConfig={eligibleBillingProvider.nameConfig}
        errorFields={errorFields}
      />
    </>
  );
}
